import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function Profile() {
  useDocumentTitle('Profile')
  return <div>Profile</div>
}
